// import React, { useState, useEffect, useMemo } from 'react';
// import { Plus, Trash2, Upload, X, ArrowLeft, FileText, Save, Eye, EyeOff, Award, Sparkles } from 'lucide-react';
// import { useNavigate, useParams, useLocation } from 'react-router-dom';
// import axios from 'axios';
// import SummaryApi from '../../common/SummaryApi';
// import ProductUploadLoader from '../SkeletonLoadings/ProductUploadLoader';
// import SelectDropdown from '../../customStyles/SelectDropdown';
// import toast from 'react-hot-toast';
// // import CustomDatePicker from './CustomDatePicker'; // Adjust path

// const ProductUploadPage = () => {
//   const navigate = useNavigate();
//   const { id } = useParams();
//   const location = useLocation();
  
//   const isEditMode = Boolean(id);
//   const isViewMode = location.state?.readOnly === true; 
//   const searchParams = new URLSearchParams(location.search);
//   const categoryFromUrl = searchParams.get("topCategory");
//   const [loading, setLoading] = useState(false);
//   const [topCategories, setTopCategories] = useState(location.state?.topCategories || []);
//   const [allSubCategories, setAllSubCategories] = useState(location.state?.subCategories || []);

//   const unitsList = useMemo(() => ['Pcs', 'Meters', 'Sets', 'Inches', 'Feet'], []);
//   const standardSizes = useMemo(() => [
//     'Free Size', 'Standard', 'Single', 'Double', 'Queen', 'King', 
//     'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5Xl', '6XL', '7XL', '8XL', '9XL', '10XL'
//   ], []);

//   const [basicInfo, setBasicInfo] = useState({
//     productName: '',
//     description: '',
//     topCategory: '',
//     subCategory: '',
//     brand: '',
//     unit: 'Pcs', 
//     taxIncluded: 'Yes',
//     isVisible: true,
//     bestSeller: false,
//     newArrivals: false,
//     highlights: [{ key: '', value: '' }]
//   });

//   const [variants, setVariants] = useState([
//     {
//       id: Date.now(),
//       colorName: '', colorCode: '#000000',
//       images: [],
//       sizes: [{ size: 'Free Size', isCustomSize: false, customSizeValue: '', price: '', mrp: '', stock: '', sku: '' }]
//     }
//   ]);

//   // --- Fetching Logic ---
//   useEffect(() => {
//     const fetchCats = async () => {
//       try {
//         const top = await axios.get(SummaryApi.getAllTopCategories.url);
//         const sub = await axios.get(SummaryApi.getAllSubCategories.url);
//         setTopCategories(top.data.data || []);
//         setAllSubCategories(sub.data.data || []);
//       } catch (err) { console.error("Category fetch failed", err); }
//     };

//     if (topCategories.length === 0) fetchCats();

//     if (isEditMode) {
//       const fetchProduct = async () => {
//         setLoading(true);
//         try {
//           const res = await axios.get(SummaryApi.getOneProduct.url(id));
//           if (res.data.success) {
//             const p = res.data.product;
//             setBasicInfo({
//               productName: p.productName || '',
//               description: p.description || '',
//               topCategory: p.topCategory?._id || p.topCategory,
//               subCategory: p.subCategory?._id || p.subCategory,
//               brand: p.brand || '',
//               unit: p.unit || 'Pcs',
//               taxIncluded: p.taxIncluded || 'Yes',
//               isVisible: p.isVisible ?? true,
//               bestSeller: p.bestSeller || false,
//               newArrivals: p.newArrivals || false,
//               highlights: p.highlights?.length ? p.highlights : [{ key: '', value: '' }]
//             });
//             setVariants(res.data.variants.map(v => ({
//               ...v, id: v._id,
//               sizes: v.sizes.map(s => ({
//                 ...s,
//                 isCustomSize: !standardSizes.includes(s.size),
//                 customSizeValue: standardSizes.includes(s.size) ? '' : s.size
//               }))
//             })));
//           }
//         } catch (err) { console.error(err); }
//         finally { setLoading(false); }
//       };
//       fetchProduct();
//     }
//   }, [id, isEditMode, topCategories.length, standardSizes]);

//   // ✅ AUTO SET TOP CATEGORY FROM URL (CORRECT PLACE)
//   useEffect(() => {
//     if (!categoryFromUrl) return;
//     if (topCategories.length === 0) return;

//     const matchedCategory = topCategories.find(
//       c => String(c._id) === String(categoryFromUrl)
//     );

//     if (matchedCategory) {
//       setBasicInfo(prev => ({
//         ...prev,
//         topCategory: matchedCategory._id
//       }));
//     }
//   }, [categoryFromUrl, topCategories]);


//   // Filtered subcategories based on selected top category
//   const filteredSubCategories = useMemo(() => {
//     return allSubCategories.filter(s => (s.topCategory?._id || s.topCategory) === basicInfo.topCategory);
//   }, [allSubCategories, basicInfo.topCategory]);

//   // Helper for size row
//   const getNewSizeRow = () => {
//     const isMeasurementUnit = ['Meters', 'Inches', 'Feet', 'Kg', 'Gm'].includes(basicInfo.unit);
//     return { 
//       size: isMeasurementUnit ? '' : 'Free Size', 
//       isCustomSize: isMeasurementUnit, 
//       customSizeValue: '', price: '', mrp: '', stock: '', sku: '' 
//     };
//   };

//   const updateSize = (vId, sIdx, field, val) => {
//     if (isViewMode) return;
//     setVariants(prev => prev.map(v => {
//       if (v.id !== vId) return v;
//       const newSizes = [...v.sizes];
//       newSizes[sIdx][field] = val;
//       return { ...v, sizes: newSizes };
//     }));
//   };

//   const handleImageUpload = (e, variantId) => {
//     if (isViewMode || !e.target.files) return;
//     const files = Array.from(e.target.files);
//     setVariants(prev => prev.map(v => v.id === variantId ? { ...v, images: [...v.images, ...files] } : v));
//   };

//   const handleSubmit = async (status) => {
//     if (isViewMode) return;
//     try {
//       setLoading(true);
//       const token = localStorage.getItem("token");
//       const cleanedVariants = variants.map(v => ({
//         ...v,
//         sizes: v.sizes.map(s => ({ ...s, size: s.isCustomSize ? s.customSizeValue : s.size }))
//       }));
//       const payload = { product: { ...basicInfo, status }, variants: cleanedVariants };
      
//       let res;
//       if (isEditMode) {
//         res = await axios.put(SummaryApi.updateProduct.url(id), payload, { headers: { Authorization: `Bearer ${token}` } });
//       } else {
//         res = await axios.post(SummaryApi.createProduct.url, payload, { headers: { Authorization: `Bearer ${token}` } });
//       }

//       if (res.data.success) {
//         const updatedVariants = res.data.variants || [];
//         await Promise.all(variants.map(async (v, idx) => {
//           const files = v.images.filter(img => img instanceof File);
//           if (files.length > 0) {
//             const form = new FormData();
//             files.forEach(f => form.append("images", f));
//             const vId = v._id || updatedVariants[idx]?._id || v.id;
//             await axios.post(SummaryApi.uploadVariantImages.url(vId), form, { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } });
//           }
//         }));
//         toast.success("Operation Success");
//         navigate("/admin-panel/all-products");
//       }
//     } catch (err) { toast.error("Failed to save"); }
//     finally { setLoading(false); }
//   };

//   if (loading) return <ProductUploadLoader />;

//   return (
//     <div className="min-h-screen pb-20 text-gray-800">
//       {/* HEADER */}
//       <div className="flex justify-between items-center mb-6">
//         <div className="flex items-center gap-2">
//           <button onClick={() => navigate(-1)} className="p-2 hover:bg-gray-100 rounded-full transition-colors"><ArrowLeft size={20} /></button>
//           <h1 className="text-lg md:text-xl font-bold">{isViewMode ? 'View' : isEditMode ? 'Edit' : 'Add'} Product</h1>
//         </div>
//         {!isViewMode && (
//           <div className="flex gap-2 md:gap-3 text-sm font-medium">
//             {!isEditMode && <button onClick={() => handleSubmit('Draft')} className="px-3 py-2 border rounded-lg bg-white flex items-center gap-2 hover:bg-gray-50 shadow-sm"><FileText size={16} /> <span className="hidden sm:inline">Save Draft</span></button>}
//             <button onClick={() => handleSubmit('Published')} className="px-4 py-2 bg-blue-600 text-white rounded-lg flex items-center gap-2 shadow-md hover:bg-blue-700 transition-colors"><Save size={16} /> <span>{isEditMode ? 'Update' : 'Publish'}</span></button>
//           </div>
//         )}
//       </div>

//       <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        
//         {/* SIDEBAR - BASIC INFO */}
//         <div className="lg:col-span-3 space-y-6">
//           <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-200">
//             <h2 className="text-xs font-bold text-gray-400 uppercase mb-4 tracking-wider">Basic Details</h2>
//             <div className="space-y-4">
//               <div>
//                 <label className="text-[11px] font-bold text-gray-500 uppercase mb-1 block">Product Name</label>
//                 <input disabled={isViewMode} type="text" placeholder="Enter name" value={basicInfo.productName} onChange={e => setBasicInfo({ ...basicInfo, productName: e.target.value })} className="w-full p-2 border rounded-lg text-sm outline-none focus:ring-1 focus:ring-blue-500 disabled:bg-gray-50" />
//               </div>
              
//               <div>
//                 <label className="text-[11px] font-bold text-gray-500 uppercase mb-1 block">Description</label>
//                 <textarea disabled={isViewMode} placeholder="Write about product..." value={basicInfo.description} onChange={e => setBasicInfo({ ...basicInfo, description: e.target.value })} className="w-full p-2 border rounded-lg text-sm h-28 outline-none focus:ring-1 focus:ring-blue-500 disabled:bg-gray-50 resize-none" />
//               </div>

//               {/* Top Category SelectDropdown */}
//               <SelectDropdown 
//                 label="Top Category"
//                 labelClassName="text-[11px] font-bold text-gray-500 uppercase mb-1 block"
//                 options={topCategories}
//                 labelKey="name"
//                 valueKey="_id"
//                 value={basicInfo.topCategory}
//                 onChange={(val) => setBasicInfo({ ...basicInfo, topCategory: val, subCategory: '' })}
//                 placeholder="Choose Top Category"
//                 searchable
//                 disabled={isViewMode}
//                 ChildClassName="!bg-white !p-2 !rounded-lg !text-sm !border-gray-200"
//               />

//               {/* Sub Category SelectDropdown */}
//               <SelectDropdown 
//                 label="Sub Category"
//                 labelClassName="text-[11px] font-bold text-gray-500 uppercase mb-1 block"
//                 options={filteredSubCategories}
//                 labelKey="name"
//                 valueKey="_id"
//                 value={basicInfo.subCategory}
//                 onChange={(val) => setBasicInfo({ ...basicInfo, subCategory: val })}
//                 placeholder="Choose Sub Category"
//                 searchable
//                 disabled={isViewMode || !basicInfo.topCategory}
//                 ChildClassName="!bg-white !p-2 !rounded-lg !text-sm !border-gray-200"
//               />

//               <div>
//                 <label className="text-[11px] font-bold text-gray-500 uppercase mb-1 block">Brand</label>
//                 <input disabled={isViewMode} type="text" placeholder="Enter Brand" value={basicInfo.brand} onChange={e => setBasicInfo({ ...basicInfo, brand: e.target.value })} className="w-full p-2 border rounded-lg text-sm outline-none focus:ring-1 focus:ring-blue-500 disabled:bg-gray-50" />
//               </div>

//               {/* Base Unit SelectDropdown */}
//               <SelectDropdown 
//                 label="Base Unit"
//                 labelClassName="text-[11px] font-bold text-gray-500 uppercase mb-1 block"
//                 options={unitsList.map(u => ({ id: u, label: u }))}
//                 value={basicInfo.unit}
//                 onChange={(val) => setBasicInfo({ ...basicInfo, unit: val })}
//                 disabled={isViewMode}
//                 ChildClassName="!bg-white !p-2 !rounded-lg !text-sm !border-gray-200"
//               />
//             </div>
//           </div>

//           <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-200">
//             <h2 className="text-xs font-bold text-gray-400 uppercase mb-4 tracking-wider">Product Badges</h2>
//             <div className="space-y-3">
//               <label className="flex items-center gap-3 cursor-pointer">
//                 <input disabled={isViewMode} type="checkbox" checked={basicInfo.bestSeller} onChange={e => setBasicInfo({ ...basicInfo, bestSeller: e.target.checked })} className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
//                 <div className="flex items-center gap-2"><Award size={16} className={basicInfo.bestSeller ? "text-orange-500" : "text-gray-400"} /><span className={`text-sm font-medium ${basicInfo.bestSeller ? "text-gray-900" : "text-gray-500"}`}>Best Seller</span></div>
//               </label>
//               <label className="flex items-center gap-3 cursor-pointer">
//                 <input disabled={isViewMode} type="checkbox" checked={basicInfo.newArrivals} onChange={e => setBasicInfo({ ...basicInfo, newArrivals: e.target.checked })} className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
//                 <div className="flex items-center gap-2"><Sparkles size={16} className={basicInfo.newArrivals ? "text-blue-500" : "text-gray-400"} /><span className={`text-sm font-medium ${basicInfo.newArrivals ? "text-gray-900" : "text-gray-500"}`}>New Arrival</span></div>
//               </label>
//             </div>
//           </div>

//           <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-200">
//             <div className="flex justify-between items-center mb-4">
//               <h2 className="text-xs font-bold text-gray-400 uppercase">Highlights</h2>
//               {!isViewMode && <button onClick={() => setBasicInfo({ ...basicInfo, highlights: [...basicInfo.highlights, { key: '', value: '' }] })} className="text-blue-600 text-xs font-bold hover:underline">+ Add</button>}
//             </div>
//             {basicInfo.highlights.map((h, i) => (
//               <div key={i} className="flex gap-2 mb-2">
//                 <input disabled={isViewMode} placeholder="Key" value={h.key} onChange={e => setBasicInfo({...basicInfo, highlights: basicInfo.highlights.map((hl, idx) => idx === i ? {...hl, key: e.target.value} : hl)})} className="w-1/2 p-2 border rounded text-xs disabled:bg-gray-50" />
//                 <input disabled={isViewMode} placeholder="Value" value={h.value} onChange={e => setBasicInfo({...basicInfo, highlights: basicInfo.highlights.map((hl, idx) => idx === i ? {...hl, value: e.target.value} : hl)})} className="w-1/2 p-2 border rounded text-xs disabled:bg-gray-50" />
//                 {!isViewMode && <button onClick={() => setBasicInfo({ ...basicInfo, highlights: basicInfo.highlights.filter((_, idx) => idx !== i) })} className="text-gray-300 hover:text-red-500"><Trash2 size={14} /></button>}
//               </div>
//             ))}
//           </div>

//           <div className={`p-4 rounded-xl border flex justify-between items-center font-bold text-sm transition-all ${basicInfo.isVisible ? 'bg-green-50 text-green-600 border-green-100' : 'bg-red-50 text-red-600 border-red-100'}`}>
//             <span>Visibility</span>
//             <button disabled={isViewMode} onClick={() => setBasicInfo({ ...basicInfo, isVisible: !basicInfo.isVisible })} className="p-1 hover:bg-white/50 rounded">{basicInfo.isVisible ? <Eye size={18} /> : <EyeOff size={18} />}</button>
//           </div>
//         </div>

//         {/* MAIN AREA - VARIANTS */}
//         <div className="lg:col-span-9 space-y-6">
//           {variants.map(v => (
//             <div key={v.id} className="bg-white p-4 md:p-6 rounded-xl shadow-sm border border-gray-200 space-y-6">
//               <div className="flex justify-between items-center border-b pb-4">
//                 <div className="flex flex-wrap gap-4 items-center">
//                   <div className="w-44">
//                     <label className="text-[10px] font-bold text-gray-400 uppercase block mb-1">Color Name</label>
//                     <input disabled={isViewMode} type="text" placeholder="e.g. Red" value={v.colorName} onChange={e => setVariants(variants.map(varnt => varnt.id === v.id ? { ...varnt, colorName: e.target.value } : varnt))} className="w-full border-b font-bold p-1 outline-none focus:border-blue-500 text-sm" />
//                   </div>
//                   <div>
//                     <label className="text-[10px] font-bold text-gray-400 uppercase block mb-1">Color Picker</label>
//                     <input disabled={isViewMode} type="color" value={v.colorCode} onChange={e => setVariants(variants.map(varnt => varnt.id === v.id ? { ...varnt, colorCode: e.target.value } : varnt))} className="w-10 h-8 cursor-pointer bg-transparent" />
//                   </div>
//                 </div>
//                 {!isViewMode && <button onClick={() => setVariants(variants.filter(varnt => varnt.id !== v.id))} className="text-red-300 hover:text-red-500 transition-colors"><Trash2 size={20} /></button>}
//               </div>

//               <div className="space-y-3">
//                 <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Image Gallery</label>
//                 <div className="flex flex-wrap gap-3">
//                   {v.images.map((img, idx) => {
//                     const preview = typeof img === 'string' ? img : URL.createObjectURL(img);
//                     return (
//                       <div key={idx} className="relative w-20 h-24 rounded-lg border overflow-hidden shadow-sm group">
//                         <img src={preview} alt="" className="w-full h-full object-cover" />
//                         {!isViewMode && <button onClick={() => setVariants(variants.map(varnt => varnt.id === v.id ? { ...varnt, images: varnt.images.filter((_, i) => i !== idx) } : varnt))} className="absolute top-1 right-1 bg-white/90 text-red-500 p-0.5 rounded-full"><X size={12} /></button>}
//                       </div>
//                     )
//                   })}
//                   {!isViewMode && (
//                     <label className="w-20 h-24 flex flex-col items-center justify-center border-2 border-dashed border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50 text-gray-400">
//                       <Upload size={18} /><span className="text-[10px] font-bold mt-1">Upload</span>
//                       <input type="file" multiple className="hidden" onChange={(e) => handleImageUpload(e, v.id)} />
//                     </label>
//                   )}
//                 </div>
//               </div>

//               <div className="bg-gray-50 rounded-xl border border-gray-200 overflow-hidden">
//                 <div className="px-4 py-3 border-b flex justify-between items-center bg-white">
//                   <span className="text-[10px] font-bold text-gray-500 uppercase tracking-widest">Stock & Pricing</span>
//                   {!isViewMode && <button onClick={() => setVariants(variants.map(varnt => varnt.id === v.id ? { ...varnt, sizes: [...varnt.sizes, getNewSizeRow()] } : varnt))} className="text-blue-600 text-[11px] font-bold hover:underline">+ Add Row</button>}
//                 </div>

//                 <div className="overflow-x-auto">
//                   <div className="min-w-[850px]">
//                     <div className="grid grid-cols-12 gap-3 px-4 py-2 bg-gray-50 text-[10px] font-bold text-gray-400 uppercase">
//                       <div className="col-span-3">{['Pcs', 'Sets'].includes(basicInfo.unit) ? 'Size / Standard' : 'Measurement / Label'}</div>
//                       <div className="col-span-2">Selling Price (₹)</div>
//                       <div className="col-span-2">MRP (₹)</div>
//                       <div className="col-span-2">Stock ({basicInfo.unit})</div>
//                       <div className="col-span-2">SKU</div>
//                       <div className="col-span-1"></div>
//                     </div>

//                     <div className="divide-y divide-gray-200 bg-white">
//                       {v.sizes.map((s, si) => (
//                         <div key={si} className="grid grid-cols-12 gap-3 px-4 py-4 items-start">
//                           <div className="col-span-3 space-y-2">
//                             {!s.isCustomSize ? (
//                               <>
//                                 {/* SelectDropdown for Standard Sizes */}
//                                 <SelectDropdown 
//                                   options={standardSizes.map(sz => ({ id: sz, label: sz }))}
//                                   value={s.size}
//                                   onChange={val => updateSize(v.id, si, 'size', val)}
//                                   disabled={isViewMode}
//                                   ChildClassName="!bg-white !p-2 !rounded-md !text-xs !border-gray-200"
//                                 />
//                                 {!isViewMode && <button onClick={() => updateSize(v.id, si, 'isCustomSize', true)} className="text-[10px] text-blue-500 font-bold hover:underline">+ Custom Label</button>}
//                               </>
//                             ) : (
//                               <div className="relative">
//                                 <input disabled={isViewMode} autoFocus placeholder={basicInfo.unit === 'Meters' ? "Ex: 6.3m" : "Ex: 30x60 Inches"} value={s.customSizeValue} onChange={e => updateSize(v.id, si, 'customSizeValue', e.target.value)} className="w-full p-2 border border-blue-200 rounded-md text-xs outline-none" />
//                                 {!isViewMode && <button onClick={() => updateSize(v.id, si, 'isCustomSize', false)} className="absolute right-2 top-2.5 text-gray-300 hover:text-red-500"><X size={14} /></button>}
//                               </div>
//                             )}
//                           </div>
//                           <div className="col-span-2"><input disabled={isViewMode} type="number" placeholder="0" value={s.price} onChange={e => updateSize(v.id, si, 'price', e.target.value)} className="w-full p-2 border rounded-md text-xs" /></div>
//                           <div className="col-span-2"><input disabled={isViewMode} type="number" placeholder="0" value={s.mrp} onChange={e => updateSize(v.id, si, 'mrp', e.target.value)} className="w-full p-2 border rounded-md text-xs" /></div>
//                           <div className="col-span-2"><input disabled={isViewMode} type="number" placeholder="0" value={s.stock} onChange={e => updateSize(v.id, si, 'stock', e.target.value)} className="w-full p-2 border rounded-md text-xs" /></div>
//                           <div className="col-span-2"><input disabled={isViewMode} type="text" placeholder="SKU Code" value={s.sku} onChange={e => updateSize(v.id, si, 'sku', e.target.value)} className="w-full p-2 border rounded-md text-xs" /></div>
//                           <div className="col-span-1 flex justify-center">{!isViewMode && <button onClick={() => setVariants(variants.map(varnt => varnt.id === v.id ? { ...varnt, sizes: varnt.sizes.filter((_, idx) => idx !== si) } : varnt))} className="text-gray-300 hover:text-red-500 mt-2 transition-colors"><Trash2 size={16} /></button>}</div>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}

//           {!isViewMode && (
//             <button onClick={() => setVariants([...variants, { id: Date.now(), colorName: '', colorCode: '#000000', images: [], sizes: [getNewSizeRow()] }])} className="w-full py-5 border-2 border-dashed border-blue-100 rounded-2xl text-blue-600 font-bold hover:bg-blue-50 transition-all flex items-center justify-center gap-2 group shadow-sm">
//               <Plus size={20} className="group-hover:scale-110 transition-transform" /> Add Another Color Variant
//             </button>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProductUploadPage;


import React, { useState, useEffect, useMemo } from 'react';
import { Plus, Trash2, Upload, X, ArrowLeft, FileText, Save, Eye, EyeOff, Award, Sparkles } from 'lucide-react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
import SummaryApi from '../../common/SummaryApi';
import ProductUploadLoader from '../SkeletonLoadings/ProductUploadLoader';
import SelectDropdown from '../../customStyles/SelectDropdown';
import toast from 'react-hot-toast';

const ProductUploadPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  
  const isEditMode = Boolean(id);
  const isViewMode = location.state?.readOnly === true; 
  const searchParams = new URLSearchParams(location.search);
  const categoryFromUrl = searchParams.get("topCategory");
  
  const [loading, setLoading] = useState(false);
  const [topCategories, setTopCategories] = useState(location.state?.topCategories || []);
  const [allSubCategories, setAllSubCategories] = useState(location.state?.subCategories || []);
  
  // ✅ New Error State
  const [errors, setErrors] = useState({});

  const unitsList = useMemo(() => ['Pcs', 'Meters', 'Sets', 'Inches', 'Feet'], []);
  const standardSizes = useMemo(() => [
    'Free Size', 'Standard', 'Single', 'Double', 'Queen', 'King', 
    'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5Xl', '6XL', '7XL', '8XL', '9XL', '10XL'
  ], []);

  const [basicInfo, setBasicInfo] = useState({
    productName: '',
    description: '',
    topCategory: '',
    subCategory: '',
    brand: '',
    unit: 'Pcs', 
    taxIncluded: 'Yes',
    isVisible: true,
    bestSeller: false,
    newArrivals: false,
    highlights: [{ key: '', value: '' }]
  });

  const [variants, setVariants] = useState([
    {
      id: Date.now(),
      colorName: '', colorCode: '#000000',
      images: [],
      sizes: [{ size: 'Free Size', isCustomSize: false, customSizeValue: '', price: '', mrp: '', stock: '', sku: '' }]
    }
  ]);

  // --- Fetching Logic ---
  useEffect(() => {
    const fetchCats = async () => {
      try {
        const top = await axios.get(SummaryApi.getAllTopCategories.url);
        const sub = await axios.get(SummaryApi.getAllSubCategories.url);
        setTopCategories(top.data.data || []);
        setAllSubCategories(sub.data.data || []);
      } catch (err) { console.error("Category fetch failed", err); }
    };

    if (topCategories.length === 0) fetchCats();

    if (isEditMode) {
      const fetchProduct = async () => {
        setLoading(true);
        try {
          const res = await axios.get(SummaryApi.getOneProduct.url(id));
          if (res.data.success) {
            const p = res.data.product;
            setBasicInfo({
              productName: p.productName || '',
              description: p.description || '',
              topCategory: p.topCategory?._id || p.topCategory,
              subCategory: p.subCategory?._id || p.subCategory,
              brand: p.brand || '',
              unit: p.unit || 'Pcs',
              taxIncluded: p.taxIncluded || 'Yes',
              isVisible: p.isVisible ?? true,
              bestSeller: p.bestSeller || false,
              newArrivals: p.newArrivals || false,
              highlights: p.highlights?.length ? p.highlights : [{ key: '', value: '' }]
            });
            setVariants(res.data.variants.map(v => ({
              ...v, id: v._id,
              sizes: v.sizes.map(s => ({
                ...s,
                isCustomSize: !standardSizes.includes(s.size),
                customSizeValue: standardSizes.includes(s.size) ? '' : s.size
              }))
            })));
          }
        } catch (err) { console.error(err); }
        finally { setLoading(false); }
      };
      fetchProduct();
    }
  }, [id, isEditMode, topCategories.length, standardSizes]);

  useEffect(() => {
    if (!categoryFromUrl) return;
    if (topCategories.length === 0) return;
    const matchedCategory = topCategories.find(c => String(c._id) === String(categoryFromUrl));
    if (matchedCategory) {
      setBasicInfo(prev => ({ ...prev, topCategory: matchedCategory._id }));
    }
  }, [categoryFromUrl, topCategories]);

  const filteredSubCategories = useMemo(() => {
    return allSubCategories.filter(s => (s.topCategory?._id || s.topCategory) === basicInfo.topCategory);
  }, [allSubCategories, basicInfo.topCategory]);

  const getNewSizeRow = () => {
    const isMeasurementUnit = ['Meters', 'Inches', 'Feet', 'Kg', 'Gm'].includes(basicInfo.unit);
    return { 
      size: isMeasurementUnit ? '' : 'Free Size', 
      isCustomSize: isMeasurementUnit, 
      customSizeValue: '', price: '', mrp: '', stock: '', sku: '' 
    };
  };

  const updateSize = (vId, sIdx, field, val) => {
    if (isViewMode) return;
    
    // Clear error for this field on change
    if(errors[`${vId}_${sIdx}_${field}`]) {
        setErrors(prev => {
            const newErr = {...prev};
            delete newErr[`${vId}_${sIdx}_${field}`];
            return newErr;
        });
    }

    setVariants(prev => prev.map(v => {
      if (v.id !== vId) return v;
      const newSizes = [...v.sizes];
      newSizes[sIdx][field] = val;
      return { ...v, sizes: newSizes };
    }));
  };

  const handleImageUpload = (e, variantId) => {
    if (isViewMode || !e.target.files) return;
    const files = Array.from(e.target.files);
    
    // Clear image error if exists
    if(errors[`${variantId}_images`]) {
        setErrors(prev => {
            const newErr = {...prev};
            delete newErr[`${variantId}_images`];
            return newErr;
        });
    }

    setVariants(prev => prev.map(v => v.id === variantId ? { ...v, images: [...v.images, ...files] } : v));
  };

  // ✅ Validation Function
  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    // Basic Info
    if (!basicInfo.productName.trim()) newErrors.productName = "Required";
    if (!basicInfo.topCategory) newErrors.topCategory = "Required";
    if (!basicInfo.subCategory) newErrors.subCategory = "Required";
    if (!basicInfo.brand.trim()) newErrors.brand = "Required";

    // Variants Validation
    variants.forEach((v) => {
        if (!v.colorName.trim()) newErrors[`${v.id}_colorName`] = "Required";
        if (v.images.length === 0) newErrors[`${v.id}_images`] = "Required";

        v.sizes.forEach((s, sIdx) => {
            const sizeValue = s.isCustomSize ? s.customSizeValue : s.size;
            if (!sizeValue) newErrors[`${v.id}_${sIdx}_size`] = "Required";
            if (!s.price) newErrors[`${v.id}_${sIdx}_price`] = "Required";
            if (!s.mrp) newErrors[`${v.id}_${sIdx}_mrp`] = "Required";
            if (!s.stock) newErrors[`${v.id}_${sIdx}_stock`] = "Required";
            // SKU is optional, so no check here
        });
    });

    if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        isValid = false;
        toast.error("Please fill all required fields highlighted in red");
    }

    return isValid;
  };

  const handleSubmit = async (status) => {
    if (isViewMode) return;
    
    // 1. Run Validation
    if (!validateForm()) return;

    try {
      setLoading(true);
      const token = localStorage.getItem("token");

      // 2. Filter Highlights: Remove empty ones (Fixes 'Path key is required' error)
      const validHighlights = basicInfo.highlights.filter(
        h => h.key.trim() !== "" && h.value.trim() !== ""
      );

      const cleanedVariants = variants.map(v => ({
        ...v,
        sizes: v.sizes.map(s => ({ ...s, size: s.isCustomSize ? s.customSizeValue : s.size }))
      }));

      // 3. Construct Payload with filtered highlights
      const payload = { 
        product: { ...basicInfo, highlights: validHighlights, status }, 
        variants: cleanedVariants 
      };
      
      let res;
      if (isEditMode) {
        res = await axios.put(SummaryApi.updateProduct.url(id), payload, { headers: { Authorization: `Bearer ${token}` } });
      } else {
        res = await axios.post(SummaryApi.createProduct.url, payload, { headers: { Authorization: `Bearer ${token}` } });
      }

      if (res.data.success) {
        const updatedVariants = res.data.variants || [];
        await Promise.all(variants.map(async (v, idx) => {
          const files = v.images.filter(img => img instanceof File);
          if (files.length > 0) {
            const form = new FormData();
            files.forEach(f => form.append("images", f));
            const vId = v._id || updatedVariants[idx]?._id || v.id;
            await axios.post(SummaryApi.uploadVariantImages.url(vId), form, { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } });
          }
        }));
        toast.success("Product Saved Successfully!");
        navigate("/admin-panel/all-products");
      }
    } catch (err) { 
        console.error(err);
        toast.error(err?.response?.data?.message || "Failed to save product"); 
    } finally { 
        setLoading(false); 
    }
  };

  // Helper to clear errors on basic info change
  const handleBasicInfoChange = (key, value) => {
    setBasicInfo({ ...basicInfo, [key]: value });
    if (errors[key]) {
        setErrors(prev => { const n = { ...prev }; delete n[key]; return n; });
    }
  };

  if (loading) return <ProductUploadLoader />;

  return (
    <div className="min-h-screen pb-20 text-gray-800">
      {/* HEADER */}
      <div className="flex justify-between items-center mb-6">
        <div className="flex items-center gap-2">
          <button onClick={() => navigate(-1)} className="p-2 hover:bg-gray-100 rounded-full transition-colors"><ArrowLeft size={20} /></button>
          <h1 className="text-lg md:text-xl font-bold">{isViewMode ? 'View' : isEditMode ? 'Edit' : 'Add'} Product</h1>
        </div>
        {!isViewMode && (
          <div className="flex gap-2 md:gap-3 text-sm font-medium">
            {!isEditMode && <button onClick={() => handleSubmit('Draft')} className="px-3 py-2 border rounded-lg bg-white flex items-center gap-2 hover:bg-gray-50 shadow-sm"><FileText size={16} /> <span className="hidden sm:inline">Save Draft</span></button>}
            <button onClick={() => handleSubmit('Published')} className="px-4 py-2 bg-blue-600 text-white rounded-lg flex items-center gap-2 shadow-md hover:bg-blue-700 transition-colors"><Save size={16} /> <span>{isEditMode ? 'Update' : 'Publish'}</span></button>
          </div>
        )}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        
        {/* SIDEBAR - BASIC INFO */}
        <div className="lg:col-span-3 space-y-6">
          <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-200">
            <h2 className="text-xs font-bold text-gray-400 uppercase mb-4 tracking-wider">Basic Details</h2>
            <div className="space-y-4">
              <div>
                <label className="text-[11px] font-bold text-gray-500 uppercase mb-1 block">Product Name <span className="text-red-500">*</span></label>
                <input 
                    disabled={isViewMode} 
                    type="text" 
                    placeholder="Enter name" 
                    value={basicInfo.productName} 
                    onChange={e => handleBasicInfoChange('productName', e.target.value)} 
                    className={`w-full p-2 border rounded-lg text-sm outline-none focus:ring-1 focus:ring-blue-500 disabled:bg-gray-50 ${errors.productName ? 'border-red-500 bg-red-50' : 'border-gray-200'}`} 
                />
              </div>
              
              <div>
                <label className="text-[11px] font-bold text-gray-500 uppercase mb-1 block">Description <span className="text-red-500">*</span></label>
                <textarea 
                    disabled={isViewMode} 
                    placeholder="Write about product..." 
                    value={basicInfo.description} 
                    onChange={e => handleBasicInfoChange('description', e.target.value)} 
                    className={`w-full p-2 border rounded-lg text-sm h-28 outline-none focus:ring-1 focus:ring-blue-500 disabled:bg-gray-50 resize-none ${errors.description ? 'border-red-500 bg-red-50' : 'border-gray-200'}`} 
                />
              </div>

              {/* Top Category SelectDropdown */}
              <div className={errors.topCategory ? "border border-red-500 rounded-lg" : ""}>
                <SelectDropdown 
                    label="Top Category"
                    labelClassName="!text-[11px] !font-bold text-gray-500 uppercase mb-1 block"
                    options={topCategories}
                    labelKey="name"
                    valueKey="_id"
                    value={basicInfo.topCategory}
                    onChange={(val) => {
                        handleBasicInfoChange('topCategory', val);
                        setBasicInfo(prev => ({ ...prev, subCategory: '' })); // Reset sub
                    }}
                    placeholder="Choose Top Category"
                    searchable
                    disabled={isViewMode}
                    ChildClassName="!bg-white !p-2 !rounded-lg !text-sm !border-gray-200"
                />
              </div>

              {/* Sub Category SelectDropdown */}
              <div className={errors.subCategory ? "border border-red-500 rounded-lg" : ""}>
                <SelectDropdown 
                    label="Sub Category"
                    labelClassName="!text-[11px] !font-bold text-gray-500 uppercase mb-1 block"
                    options={filteredSubCategories}
                    labelKey="name"
                    valueKey="_id"
                    value={basicInfo.subCategory}
                    onChange={(val) => handleBasicInfoChange('subCategory', val)}
                    placeholder="Choose Sub Category"
                    searchable
                    disabled={isViewMode || !basicInfo.topCategory}
                    ChildClassName="!bg-white !p-2 !rounded-lg !text-sm !border-gray-200"
                />
              </div>

              <div>
                <label className="text-[11px] font-bold text-gray-500 uppercase mb-1 block">Brand <span className="text-red-500">*</span></label>
                <input 
                    disabled={isViewMode} 
                    type="text" 
                    placeholder="Enter Brand" 
                    value={basicInfo.brand} 
                    onChange={e => handleBasicInfoChange('brand', e.target.value)} 
                    className={`w-full p-2 border rounded-lg text-sm outline-none focus:ring-1 focus:ring-blue-500 disabled:bg-gray-50 ${errors.brand ? 'border-red-500 bg-red-50' : 'border-gray-200'}`} 
                />
              </div>

              {/* Base Unit SelectDropdown */}
              <SelectDropdown 
                label="Base Unit"
                labelClassName="!text-[11px] !font-bold text-gray-500 uppercase mb-1 block"
                options={unitsList.map(u => ({ id: u, label: u }))}
                value={basicInfo.unit}
                onChange={(val) => setBasicInfo({ ...basicInfo, unit: val })}
                disabled={isViewMode}
                ChildClassName="!bg-white !p-2 !rounded-lg !text-sm !border-gray-200"
              />
            </div>
          </div>

          <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-200">
            <h2 className="text-xs font-bold text-gray-400 uppercase mb-4 tracking-wider">Product Badges</h2>
            <div className="space-y-3">
              <label className="flex items-center gap-3 cursor-pointer">
                <input disabled={isViewMode} type="checkbox" checked={basicInfo.bestSeller} onChange={e => setBasicInfo({ ...basicInfo, bestSeller: e.target.checked })} className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                <div className="flex items-center gap-2"><Award size={16} className={basicInfo.bestSeller ? "text-orange-500" : "text-gray-400"} /><span className={`text-sm font-medium ${basicInfo.bestSeller ? "text-gray-900" : "text-gray-500"}`}>Best Seller</span></div>
              </label>
              <label className="flex items-center gap-3 cursor-pointer">
                <input disabled={isViewMode} type="checkbox" checked={basicInfo.newArrivals} onChange={e => setBasicInfo({ ...basicInfo, newArrivals: e.target.checked })} className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                <div className="flex items-center gap-2"><Sparkles size={16} className={basicInfo.newArrivals ? "text-blue-500" : "text-gray-400"} /><span className={`text-sm font-medium ${basicInfo.newArrivals ? "text-gray-900" : "text-gray-500"}`}>New Arrival</span></div>
              </label>
            </div>
          </div>

          <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-200">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xs font-bold text-gray-400 uppercase">Highlights</h2>
              {!isViewMode && <button onClick={() => setBasicInfo({ ...basicInfo, highlights: [...basicInfo.highlights, { key: '', value: '' }] })} className="text-blue-600 text-xs font-bold hover:underline">+ Add</button>}
            </div>
            {basicInfo.highlights.map((h, i) => (
              <div key={i} className="flex gap-2 mb-2">
                <input disabled={isViewMode} placeholder="Key" value={h.key} onChange={e => setBasicInfo({...basicInfo, highlights: basicInfo.highlights.map((hl, idx) => idx === i ? {...hl, key: e.target.value} : hl)})} className="w-1/2 p-2 border rounded text-xs disabled:bg-gray-50" />
                <input disabled={isViewMode} placeholder="Value" value={h.value} onChange={e => setBasicInfo({...basicInfo, highlights: basicInfo.highlights.map((hl, idx) => idx === i ? {...hl, value: e.target.value} : hl)})} className="w-1/2 p-2 border rounded text-xs disabled:bg-gray-50" />
                {!isViewMode && <button onClick={() => setBasicInfo({ ...basicInfo, highlights: basicInfo.highlights.filter((_, idx) => idx !== i) })} className="text-gray-300 hover:text-red-500"><Trash2 size={14} /></button>}
              </div>
            ))}
            <p className="text-[10px] text-gray-400 mt-2 italic">* Empty highlights will be removed automatically.</p>
          </div>

          <div className={`p-4 rounded-xl border flex justify-between items-center font-bold text-sm transition-all ${basicInfo.isVisible ? 'bg-green-50 text-green-600 border-green-100' : 'bg-red-50 text-red-600 border-red-100'}`}>
            <span>Visibility</span>
            <button disabled={isViewMode} onClick={() => setBasicInfo({ ...basicInfo, isVisible: !basicInfo.isVisible })} className="p-1 hover:bg-white/50 rounded">{basicInfo.isVisible ? <Eye size={18} /> : <EyeOff size={18} />}</button>
          </div>
        </div>

        {/* MAIN AREA - VARIANTS */}
        <div className="lg:col-span-9 space-y-6">
          {variants.map(v => (
            <div key={v.id} className="bg-white p-4 md:p-6 rounded-xl shadow-sm border border-gray-200 space-y-6">
              <div className="flex justify-between items-center border-b pb-4">
                <div className="flex flex-wrap gap-4 items-center">
                  <div className="w-44">
                    <label className="text-[10px] font-bold text-gray-400 uppercase block mb-1">Color Name <span className="text-red-500">*</span></label>
                    <input 
                        disabled={isViewMode} 
                        type="text" 
                        placeholder="e.g. Red" 
                        value={v.colorName} 
                        onChange={e => {
                            setVariants(variants.map(varnt => varnt.id === v.id ? { ...varnt, colorName: e.target.value } : varnt));
                            if(errors[`${v.id}_colorName`]) setErrors(prev => { const n = {...prev}; delete n[`${v.id}_colorName`]; return n; });
                        }} 
                        className={`w-full border-b font-bold p-1 outline-none focus:border-blue-500 text-sm ${errors[`${v.id}_colorName`] ? 'border-red-500 bg-red-50' : ''}`} 
                    />
                  </div>
                  <div>
                    <label className="text-[10px] font-bold text-gray-400 uppercase block mb-1">Color Picker</label>
                    <input disabled={isViewMode} type="color" value={v.colorCode} onChange={e => setVariants(variants.map(varnt => varnt.id === v.id ? { ...varnt, colorCode: e.target.value } : varnt))} className="w-10 h-8 cursor-pointer bg-transparent" />
                  </div>
                </div>
                {!isViewMode && <button onClick={() => setVariants(variants.filter(varnt => varnt.id !== v.id))} className="text-red-300 hover:text-red-500 transition-colors"><Trash2 size={20} /></button>}
              </div>

              <div className="space-y-3">
                <label className={`text-[10px] font-bold text-gray-400 uppercase tracking-widest ${errors[`${v.id}_images`] ? 'text-red-500' : ''}`}>
                    Image Gallery <span className="text-red-500">*</span> {errors[`${v.id}_images`] && "(At least one image required)"}
                </label>
                <div className={`flex flex-wrap gap-3 p-2 rounded-lg ${errors[`${v.id}_images`] ? 'bg-red-50 border border-red-200' : ''}`}>
                  {v.images.map((img, idx) => {
                    const preview = typeof img === 'string' ? img : URL.createObjectURL(img);
                    return (
                      <div key={idx} className="relative w-20 h-24 rounded-lg border overflow-hidden shadow-sm group">
                        <img src={preview} alt="" className="w-full h-full object-cover" />
                        {!isViewMode && <button onClick={() => setVariants(variants.map(varnt => varnt.id === v.id ? { ...varnt, images: varnt.images.filter((_, i) => i !== idx) } : varnt))} className="absolute top-1 right-1 bg-white/90 text-red-500 p-0.5 rounded-full"><X size={12} /></button>}
                      </div>
                    )
                  })}
                  {!isViewMode && (
                    <label className="w-20 h-24 flex flex-col items-center justify-center border-2 border-dashed border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50 text-gray-400">
                      <Upload size={18} /><span className="text-[10px] font-bold mt-1">Upload</span>
                      <input type="file" multiple className="hidden" onChange={(e) => handleImageUpload(e, v.id)} />
                    </label>
                  )}
                </div>
              </div>

              <div className="bg-gray-50 rounded-xl border border-gray-200 overflow-hidden">
                <div className="px-4 py-3 border-b flex justify-between items-center bg-white">
                  <span className="text-[10px] font-bold text-gray-500 uppercase tracking-widest">Stock & Pricing</span>
                  {!isViewMode && <button onClick={() => setVariants(variants.map(varnt => varnt.id === v.id ? { ...varnt, sizes: [...varnt.sizes, getNewSizeRow()] } : varnt))} className="text-blue-600 text-[11px] font-bold hover:underline">+ Add Row</button>}
                </div>

                <div className="overflow-x-auto">
                  <div className="min-w-[850px]">
                    <div className="grid grid-cols-12 gap-3 px-4 py-2 bg-gray-50 text-[10px] font-bold text-gray-400 uppercase">
                      <div className="col-span-3">{['Pcs', 'Sets'].includes(basicInfo.unit) ? 'Size / Standard' : 'Measurement / Label'} <span className="text-red-500">*</span></div>
                      <div className="col-span-2">Selling Price (₹) <span className="text-red-500">*</span></div>
                      <div className="col-span-2">MRP (₹) <span className="text-red-500">*</span></div>
                      <div className="col-span-2">Stock ({basicInfo.unit}) <span className="text-red-500">*</span></div>
                      <div className="col-span-2">SKU <span className="text-gray-300 font-normal">(Optional)</span></div>
                      <div className="col-span-1"></div>
                    </div>

                    <div className="divide-y divide-gray-200 bg-white">
                      {v.sizes.map((s, si) => (
                        <div key={si} className="grid grid-cols-12 gap-3 px-4 py-4 items-start">
                          <div className="col-span-3 space-y-2">
                            {!s.isCustomSize ? (
                              <div className={errors[`${v.id}_${si}_size`] ? "border border-red-500 rounded-md" : ""}>
                                <SelectDropdown 
                                  options={standardSizes.map(sz => ({ id: sz, label: sz }))}
                                  value={s.size}
                                  onChange={val => updateSize(v.id, si, 'size', val)}
                                  disabled={isViewMode}
                                  ChildClassName="!bg-white !p-2 !rounded-md !text-xs !border-gray-200"
                                />
                                {!isViewMode && <button onClick={() => updateSize(v.id, si, 'isCustomSize', true)} className="text-[10px] text-blue-500 font-bold hover:underline">+ Custom Label</button>}
                              </div>
                            ) : (
                              <div className="relative">
                                <input 
                                    disabled={isViewMode} 
                                    autoFocus 
                                    placeholder={basicInfo.unit === 'Meters' ? "Ex: 6.3m" : "Ex: 30x60 Inches"} 
                                    value={s.customSizeValue} 
                                    onChange={e => updateSize(v.id, si, 'customSizeValue', e.target.value)} 
                                    className={`w-full p-2 border rounded-md text-xs outline-none ${errors[`${v.id}_${si}_size`] ? 'border-red-500 bg-red-50' : 'border-blue-200'}`} 
                                />
                                {!isViewMode && <button onClick={() => updateSize(v.id, si, 'isCustomSize', false)} className="absolute right-2 top-2.5 text-gray-300 hover:text-red-500"><X size={14} /></button>}
                              </div>
                            )}
                          </div>
                          
                          <div className="col-span-2">
                            <input 
                                disabled={isViewMode} 
                                type="number" 
                                placeholder="0" 
                                value={s.price} 
                                onChange={e => updateSize(v.id, si, 'price', e.target.value)} 
                                className={`w-full p-2 border rounded-md text-xs ${errors[`${v.id}_${si}_price`] ? 'border-red-500 bg-red-50' : ''}`} 
                            />
                          </div>
                          
                          <div className="col-span-2">
                            <input 
                                disabled={isViewMode} 
                                type="number" 
                                placeholder="0" 
                                value={s.mrp} 
                                onChange={e => updateSize(v.id, si, 'mrp', e.target.value)} 
                                className={`w-full p-2 border rounded-md text-xs ${errors[`${v.id}_${si}_mrp`] ? 'border-red-500 bg-red-50' : ''}`} 
                            />
                          </div>
                          
                          <div className="col-span-2">
                            <input 
                                disabled={isViewMode} 
                                type="number" 
                                placeholder="0" 
                                value={s.stock} 
                                onChange={e => updateSize(v.id, si, 'stock', e.target.value)} 
                                className={`w-full p-2 border rounded-md text-xs ${errors[`${v.id}_${si}_stock`] ? 'border-red-500 bg-red-50' : ''}`} 
                            />
                          </div>
                          
                          <div className="col-span-2">
                            <input 
                                disabled={isViewMode} 
                                type="text" 
                                placeholder="SKU Code" 
                                value={s.sku} 
                                onChange={e => updateSize(v.id, si, 'sku', e.target.value)} 
                                className="w-full p-2 border rounded-md text-xs" 
                            />
                          </div>
                          
                          <div className="col-span-1 flex justify-center">{!isViewMode && <button onClick={() => setVariants(variants.map(varnt => varnt.id === v.id ? { ...varnt, sizes: varnt.sizes.filter((_, idx) => idx !== si) } : varnt))} className="text-gray-300 hover:text-red-500 mt-2 transition-colors"><Trash2 size={16} /></button>}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}

          {!isViewMode && (
            <button onClick={() => setVariants([...variants, { id: Date.now(), colorName: '', colorCode: '#000000', images: [], sizes: [getNewSizeRow()] }])} className="w-full py-5 border-2 border-dashed border-blue-100 rounded-2xl text-blue-600 font-bold hover:bg-blue-50 transition-all flex items-center justify-center gap-2 group shadow-sm">
              <Plus size={20} className="group-hover:scale-110 transition-transform" /> Add Another Color Variant
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductUploadPage;